/**
 * Which type of loading screen is displayed or if the loading screen is skipped altogether.
 * Auto will become simple for now.
 */
export var LoadingScreen;
(function (LoadingScreen) {
    LoadingScreen["Auto"] = "Auto";
    LoadingScreen["Skip"] = "Skip";
    LoadingScreen["Simple"] = "Simple";
})(LoadingScreen || (LoadingScreen = {}));
//# sourceMappingURL=loading-screen.js.map